import React, { useEffect, useState } from "react";
import SideMenu from "./SideMenu";
import CareerContentCard from "./CareerContentCard";
import "./careerSections.css";
// Example menu and content data
const menuData = [
  {
    title: "What UAIC Offers",
    collapsible: true,
    items: [
      { key: "careers", label: "Careers" },
      { key: "benefits", label: "Benefits" },
      { key: "diversity", label: "Diversity" },
      { key: "faq", label: "FAQ" },
    ],
  },
  {
    title: "Recruiting Events",
    collapsible: true,
    items: [{ key: "jobFairs", label: "Job Fairs" }],
  },
  {
    title: "Career Paths",
    collapsible: true,
    items: [
      { key: "accounting", label: "Accounting" },
      { key: "claims", label: "Claims" },
      { key: "corporate", label: "Corporate & Executive" },
      { key: "informationTechnology", label: "Information Technology" },
      { key: "underwriting", label: "Underwriting" },
    ],
  },
];

const contentData = {
  benefits: {
    heading: "Benefits",
    subHeading: "Employment Opportunities",
    body: `<p className="mb-4 text-gray-700 leading-relaxed">
        As you'd expect, we offer standard benefits including health care, dental and vision. But at UAIC, benefits 
        go far beyond standard. UAIC wants its associates to be enriched both in and out of the office. We're 
        pleased we can offer a highly competitive and comprehensive benefits package to our employees.
      </p>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
        Our benefits package is designed to help our associates stay healthy, meet their long-term financial 
        goals, as well as balance the demands of work and personal life. UAIC rewards hard work, dedication, 
        and creativity with competitive salaries and a generous bonus system.
      </p>
      
      <style>
  .custom-benefits-list {
    font-family: 'Text/Font-family', sans-serif; /* Replace with actual font-family */
    font-weight: 400;
    font-size: 16px;
    line-height: 1.79;
    letter-spacing: 0;
    color: #515050!important; 
  }

  .custom-benefits-list ul {
    padding-left: 1.25rem!important;
    list-style-type: disc;
  }
    li:hover {
    text-decoration: none;
    color: #515050;
}
    .list-items
    {
    font-family: 'Text/Font-family', sans-serif; 
    font-weight: 400;
    font-size: 16px;
    line-height: 1.79;
    letter-spacing: 0;
    color: #515050!important; 
    }
    


  .custom-benefits-list li {
    margin-bottom: 0.5rem; /* space between list items */
  }
</style>

<div className="custom-benefits-list">
  <p>The information below provides a list of our employee benefits:</p>
  <ul>
    <li className="list-items">• Group Health Insurance (Medical, Dental, Rx)</li>
    <li className="list-items">• Vision Plan</li>
    <li className="list-items">• Flexible Spending Accounts (FSA)</li>
    <li className="list-items">• 401K savings plan (Employer match 50% up to 8% of employee compensation)</li>
    <li className="list-items">• Short Term Disability</li>
    <li className="list-items">• Long Term Disability Insurance</li>
    <li className="list-items">• Life, Accidental Death & Dismemberment Insurance</li>
    <li className="list-items">• Voluntary Life Insurance</li>
    <li className="list-items">• Paid Time Off (PTO) + 1 Floating Holiday</li>
    <li className="list-items">• 7 Paid Holidays per year</li>
  </ul>
</div>

`,
    link: { url: "https://uaig.applytojob.com/apply", text: "Apply" },
  },
  careers: {
    heading: "Careers",
    subHeading: "Employment Opportunities",
    body: `<p className="mb-4 text-gray-700 leading-relaxed">
        UAIC is always looking for smart, ethical, passionate, creative and energetic people to join our team. If we don't have any positions posted at the moment, please check back with us.
      </p>
      `,
    link: { url: "https://uaig.applytojob.com/apply", text: "Apply" },
  },
  diversity: {
    heading: "Diversity",
    subHeading: "",
    body: `<p className="mb-4 text-gray-700 leading-relaxed">
        We believe that a key component of making UAIC a great place to work is each of us understanding and welcoming our differences and similarities--<strong>people with different backgrounds and experiences bring important perspectives to UAIC's business challenges and thinking.</strong> Crucial to sustaining UAIC's unique culture is having an organization where everyone who works here feels like they are part of one community.
      </p>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
        Here in UAIC, we think that hiring people who bring added diversity to our work force is important to our future. With a diverse work force, we all benefit--and so do our customers.
      </p>
`,
  },
  faq: {
    heading: "Frequently Asked Questions",
    subHeading: "",
    body: `<div className="text-sm text-blue-600 mb-8">
        Do you have a question about getting a job at UAIC? Here is a list of frequently asked questions that we receive from applicants. If you don't see your question or answer here, please <a href="https://www.uaig.net/uaichome/#/uaichome/contact" className="underline hover:text-blue-800">contact us</a>.
      </div>

      <div className="space-y-6">
        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Is UAIC hiring?</h2>
          <p className="text-gray-700">
            Yes, many of our offices are hiring skilled professionals for a variety of positions, including customer service, data entry clerks, claims and underwriting. Specific job openings, shifts, and training classes will vary from office to office. Additionally, our corporate office recruits information technology professionals, attorneys and accounting associates. For a list of current opportunities, please <a href="https://uaig.applytojob.com/apply" className="text-blue-600 hover:text-blue-800">click here</a>.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">What are the qualifications needed to work at UAIC?</h2>
          <p className="text-gray-700">
            For our sales, customer service, claims and auto damage positions, we are looking for candidates with strong communication and computer skills, and the ability to multi-task and assist our customers in a friendly, professional manner. We provide extensive training in each area; therefore a desire to learn and apply those skills is important to our associates' careers. No prior insurance industry experience is required!
          </p>
          <p className="text-gray-700 mt-2">
            Our management development programs, and analytical and technical positions have specific requirements. You'll want to review each job for more information.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">How old do you have to be to work for UAIC?</h2>
          <p className="text-gray-700">
            For full-time career positions, applicants must be at least 18 years of age to be employed by UAIC. Some offices offer work-study or internship programs for high school and/or college students. In these cases, work permits for minors may be required.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Do I need a high school diploma?</h2>
          <p className="text-gray-700">
            For full-time careers in sales, customer service, claims and auto damage we require a high school diploma or equivalent. Other positions, including our management development programs, analyst, actuary and information technology positions require a college degree. Some clerical positions do not have a minimum education requirement. You'll want to check with the local Human Resources office if you have further questions.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Do I have to apply online?</h2>
          <p className="text-gray-700">
            We strongly encourage candidates to email us your resume.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Can I apply in person?</h2>
          <p className="text-gray-700">
            Yes, you are welcome to apply in person and submit your application. If a recruiter is available to review your information, you may have the opportunity to interview as well. However, we cannot guarantee that you'll receive an interview on the same day.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">How do I set up an interview?</h2>
          <p className="text-gray-700">
            Once you've applied for employment, we will review your application. If your knowledge, skills, and abilities match what we are looking for, you will be contacted directly to set up an interview.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Will there be pre-employment testing?</h2>
          <p className="text-gray-700">
            Our goal is to hire the best people for the right positions! Therefore, we conduct a series of pre-employment assessments in order to evaluate the skills and abilities of potential associates. Depending on the job for which you are applying, testing may include a review of basic skills, role-playing and computerized assessments.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">I have UAIC insurance. Do I have a better chance of getting hired?</h2>
          <p className="text-gray-700">
            No, it is the policy of UAIC to seek, employ, and assign the best qualified employees in all of our offices. We are an equal opportunity employer.
          </p>
        </div>
      </div>
`,
  },
  jobFairs: {
    heading: "Job Fairs",
    subHeading: "",
    body: `<section className="bg-white rounded-lg shadow-sm p-6">
        
        <p className="text-gray-700 mb-4">
          Find out when United Automobile Insurance Company will visit your area and select a state for more information. We only list areas with scheduled events, so please check back soon if you don't see your area on the list today.
        </p>
        
        <p className="italic text-gray-600 border-l-4 border-blue-200 pl-4 py-2">
          Note: We currently do not have any job fairs scheduled. So please check back soon.
        </p>
      </section>

      <section className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex items-center gap-3 mb-6">
          <Briefcase className="w-6 h-6 text-blue-600" />
          <h2 className="text-2xl font-bold text-gray-900">Tips for Participating in Job Fairs</h2>
        </div>

        <div className="space-y-6">
          <div>
            <p className="text-gray-800">
              <strong className="font-bold">First impressions are lasting ones</strong> so treat the career fairs that you are attending like a job interview. Come dressed for success in conservative attire, with a winning attitude, and ready to answer probing questions.
            </p>
          </div>

          <div>
            <p className="text-gray-800">
              <strong className="font-semibold">Periodically attend these events</strong> even when you are not necessarily looking for a job to see what opportunities are out there, and to gain a perspective on where you fit in the job marketplace.
            </p>
          </div>

          <div>
            <p className="text-gray-800">
              <strong className="font-semibold">Be prepared</strong> by bringing the following: a pen, note pad and stack of resumes. You should also bring a portfolio or carryall that has easily accessible storage areas. Wear comfortable, professional-looking shoes designed for standing long periods of time.
            </p>
          </div>

          <div>
            <p className="text-gray-800">
              <strong className="font-semibold">Your resume should be scannable, short and professional</strong> on white paper that is free of graphics, photographs or fancy print styles, but also containing larger margins for interviewer notes.
            </p>
          </div>

          <div>
            <p className="text-gray-800">
              If they distribute name tags at the conference or job fair, by all means use them.
            </p>
          </div>

          <div>
            <p className="text-gray-800">
              <strong className="font-semibold">Arrive early</strong> to avoid having to stand in long lines. Large companies with high profiles will have the longest lines.
            </p>
          </div>

          <div>
            <p className="text-gray-800">
              <strong className="font-semibold">Be prepared to assertively introduce yourself</strong> giving your best handshake, showing enthusiasm and making eye contact with the interviewer. Be concise, polite and direct, as you only have brief period of time to obtain the information that you need and to make an impression.
            </p>
          </div>

          <div>
            <p className="text-gray-800">
              <strong className="font-semibold">Finding out about position needs, company culture and diversity.</strong> These questions will help you figure out if the company is a good match for you. Use the information that you obtain from your company research, and the questions that you ask to sell your skills that address their needs.
            </p>
          </div>
        </div>
      </section>
`,
  },
  accounting: {
    heading: "Accounting",
    subHeading: "",
    body: `<p className="mb-4 text-gray-700 leading-relaxed">
        Accounting, auditing, and bookkeeping services serve key functions in America's (and the world's) economic engine. In such publications as The Bottom Line, the global significance of the accounting profession has long been confirmed: The world's capital markets rely on financial statements certified by independent auditors. If the integrity of those statements could not be trusted, investment would come to a halt and economic growth would be paralyzed.
      </p>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
      If you choose to join this dynamic department, you will be assisting in safeguarding our assets, providing timely and accurate external reporting, optimizing cash flow and presenting financial analysis of trends and key issues. With our use of advanced technology, employee skills and experience, we help develop financial solutions to assist in the success of UAIC.
      </p>
      <p className="mb-4 text-gray-700 leading-relaxed">
        Currently we are not hiring in the accounting department. For a complete list of current opportunities, please  <a href="https://uaig.applytojob.com/apply" className="underline hover:text-blue-800">click here</a>. .
      </p>`,
  },
  claims: {
    heading: "Claims",
    subHeading: "",
    body: `<p className="mb-4 text-gray-700 leading-relaxed">
Claims adjuster is a term used to describe someone who evaluates the damage caused to property or people when an insurance related accident occurs.

      </p>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
An adjuster will frequently verify that coverage applies through an insurance policy, investigate liability for the damages caused, and make restitution to the injured person based on their physical, emotional, or physical property damages.

      </p>
`,
  },
  corporate: {
    heading: "Corporate & Executive Professionals",
    subHeading: "",
    body: `<p className="mb-4 text-gray-700 leading-relaxed">
Human Resources, Actuary, Marketing and lots more ... wherever your professional interests lie, UAIC has great careers for the right people.

      </p>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
UAIC's corporate headquarters is located in Miami Gardens, Florida. Here, you will find our Finance and Accounting, Marketing, Underwriting, and Legal departments.

      </p>
      <p className="mb-4 text-gray-700 leading-relaxed">
Associates working at our headquarters support our business operations, work closely with our regional offices, and make real contributions to the company's bottom line. Our Florida area office offers rewarding career opportunities in an exciting metropolitan setting.


      </p>

      
      <p className="mb-4 text-gray-700 leading-relaxed">
        For a list of current opportunities, please  <a href="https://uaig.applytojob.com/apply" className="underline hover:text-blue-800">click here</a>. 
      </p>`,
  },
  informationTechnology: {
    heading: "Information Technology",
    subHeading: "",
    body: `<p className="mb-4 text-gray-700 leading-relaxed">Not only is UAIC one of the fastest growing casualty insurance companies in the United States, we are also a hi-tech powerhouse. By using the latest technology, our Miami Gardens based IT team works diligently to position UAIC as a leader in our industry.</p>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
      In IT, we design the technology solutions that have improved online customer service, and claims experience to our customers, while maintaining a user-friendly environment. UAIC offers rewarding, full-time IT job opportunities within our systems operations, information services, and internet business units.

</p>
`,
  },
  underwriting: {
    heading: "Underwriting",
    subHeading: "",
    body: `<p className="mb-4 text-gray-700 leading-relaxed">As an Underwriter Representative, you will be responsible for executing the sub-prime underwriting process within a regional office and developing & maintaining relationships with clients within a designated market.</p>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
      In this role you will perform the following functions:
      </p>
      <ul class="ml-3 ">
      <li class="mb-3 fw-normal">Communicate adverse decisions to clients while maintaining strong business rapport; negotiate decision change requests as warranted.</li>
      <li class="mb-3 fw-normal">Manage workflows within assigned markets to enable excellent servicing levels, responsiveness, and accessibility.</li>
      <li class="mb-3 fw-normal">Negotiate and resolve program and product policy exceptions regarding residuals, pricing, and documentation issues.</li>
      <li class="mb-3 fw-normal">In cooperation with the Relationship Manager, contribute to the market's profitability level through volume generation and efficiency management.</li>
`,
  },

  // Add more content for other keys
};

const CareerSection = ({ responsiveState, selectedTab }) => {
  const [selectedKey, setSelectedKey] = useState(selectedTab);
  useEffect(() => {
    setSelectedKey(selectedTab);
  }, [selectedTab]);

  return (
    <div
      className={`${responsiveState ? "mt-2" : "mt-5"}`}
      style={{ display: "flex", width: "100%", gap: 32 }}
    >
      <div
        className="container"
        style={{ maxWidth: "1350px", margin: "0 auto" }}
      >
        <div
          className={`${
            responsiveState
              ? "rounded-lg shadow-sm mt-1 row"
              : "rounded-lg shadow-sm mt-1 row p-3"
          }`}
          style={{ backgroundColor: "#F1F7FD" }}
        >
          <div className=" col-md-4 mt-2">
            <SideMenu
              menuData={menuData}
              selectedKey={selectedKey}
              onSelect={setSelectedKey}
            />
          </div>
          <div className=" col-md-8 mt-2">
            <CareerContentCard
              responsiveStatus={responsiveState}
              {...contentData[selectedKey]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerSection;
